module.exports = __webpack_public_path__ + "img/tooltip.b5d640d4.svg";